import * as React from "react";
const SvgUnchecked = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 0.5, y: 0.5, width: 19, height: 19, rx: 1.5, fill: "white", stroke: "currentColor" }));
export default SvgUnchecked;
